import React from "react";

const Tip = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="#FCEBEA" fillRule="evenodd">
      <path d="M10 0C4.476 0 0 4.476 0 10s4.476 10 10 10 10-4.476 10-10S15.524 0 10 0z" />
      <path
        d="M10.407 13.609c-.116.521.698.695 1.395.087l.35.26c-.466.61-1.164 1.044-2.326 1.044-1.163 0-1.628-.435-1.628-1.043 0-.174 0-.348.116-.696l.814-3.218c.116-.695-.698-.782-1.28-.26L7.5 9.522c.349-.522 1.163-.957 2.21-.957 1.162 0 1.627.435 1.627 1.13 0 .175 0 .435-.116.61l-.814 3.304zm.581-6.261c-.814 0-1.511-.435-1.511-1.13 0-.696.581-1.218 1.511-1.218.814 0 1.512.609 1.512 1.217 0 .61-.581 1.13-1.512 1.13z"
        fill="#EF5753"
      />
    </g>
  </svg>
);

export default Tip;



// WEBPACK FOOTER //
// ../shop_main/images/tip.js